import React from "react";
import { Link } from "react-router-dom";
import logo from "./assets/images/logo.svg";
import logoCmetric from "./assets/images/logo-cmetric.png";

function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="site-footer-main">
          <div className="site-footer-brand">
            <Link to="/" aria-label="Aivio home"><img src={logo} alt="Aivio" /></Link>
            <p>Enterprise AI agents that work across your business systems, built around the way your team works.</p>
            <a className="cmetric-link" href="https://www.c-metric.com/" target="_blank" rel="noreferrer"><img src={logoCmetric} alt="C-Metric" /></a>
          </div>
          <div className="site-footer-links">
            <div><h3>Explore</h3><Link to="/">Home</Link><Link to="/use-cases">Use cases</Link><Link to="/know-your-cost">Know your cost</Link></div>
            <div><h3>Account</h3><Link to="/login">Login</Link><Link to="/register">Register</Link><Link to="/privacy-policy">Privacy policy</Link></div>
            <div><h3>Get in touch</h3><a href="mailto:info@c-metric.com">info@c-metric.com</a><a href="tel:+18564827700">+1 (856) 482-7700</a><span>C-Metric Solutions</span></div>
          </div>
        </div>
        <div className="site-footer-bottom"><span>© 2026 C-Metric. All rights reserved.</span><span>Powered by C-Metric</span></div>
      </div>
    </footer>
  );
}

export default Footer;

